// React
import React from 'react';

// Material UI
import { Grid, Typography } from '@material-ui/core';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveApplication, payInAdvancedYears } from 'aurora-composition/modules/rentPayment/actions';
// components
import { ADGMSelect, ADGMTextField } from 'aurora-components';

// utils
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { fortmatDates, formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';

function PayRentInAdvance({ classes, isEditable }) {
  const dispatch = useDispatch();

  const { payInAdvanceYears, application } = useSelector(state => state.RentPaymentReducer);

  const {
    payInAdvanceRent,
    payInAdvanceRentVat,
    annualRentAmount,
    maxPayInAdvanceYears,
    payInAdvanceEndDate,
    payInAdvanceStartDate,
  } = application;

  // Pay in advance years drop down list should not exceed the contract end date
  const PayInAdvanceYearsNumbersDropDown = maxPayInAdvanceYears > 0 ? [...Array(maxPayInAdvanceYears)?.keys()] : [];

  function handleSelectPayInAdvanceYears(_, value) {
    const Years = value.value;
    dispatch(payInAdvancedYears(value.value));
    dispatch(
      saveApplication({
        applicationId: application?.applicationId,
        payInAdvanceYears: Years,
      }),
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={10}>
        <Typography className={classes.textBold}>{keyEmptyCheck('pay_rent_in_advance')}</Typography>
      </Grid>

      {!isEditable && (
        <Grid item xs={2}>
          <Typography className={classNames(classes.textBold, classes.textEnd)}>
            {keyEmptyCheck('years_2', { s: payInAdvanceYears })}
          </Typography>
        </Grid>
      )}

      {isEditable && (
        <>
          <Grid item xs={6}>
            <ADGMTextField
              disabled
              required
              id='annual_rent_amount'
              name='annual_rent_amount'
              // placeholder={intl.formatMessage({ ...messages.AED_AMOUNT }, { num: annualRentAmount ?? 0 })}
              label={keyEmptyCheck('annual_rent_amount')}
              value={annualRentAmount?.toFixed(2)}
              onChange={() => {}}
            />
          </Grid>
          <Grid item xs={6}>
            <ADGMSelect
              required
              name='payInAdvanceYears'
              type='select'
              placeholder={payInAdvanceYears}
              label={keyEmptyCheck('pay_in_advance')}
              options={PayInAdvanceYearsNumbersDropDown?.map(number => {
                return { label: number + 1, value: number + 1 };
              })}
              value={payInAdvanceYears}
              // eslint-disable-next-line react/jsx-no-bind
              onChange={handleSelectPayInAdvanceYears}
              customClasses={{ select: classes.adgmSelect }}
            />
          </Grid>
        </>
      )}

      <Grid item xs={7}>
        <Typography className={classes.textLight}>
          {keyEmptyCheck('total_due_rent_amount_for_the_period', { s: '' })}
        </Typography>
      </Grid>

      <Grid item xs={5}>
        <Typography className={classNames(classes.textEnd, classes.textBold)}>
          {keyEmptyCheck('AED_amount', {
            num: formatCurrencyWithoutCurrency(payInAdvanceRent + payInAdvanceRentVat ?? 0),
          })}
        </Typography>
      </Grid>

      <Grid item xs={7}>
        <Typography className={classes.textLight}>
          {fortmatDates(payInAdvanceStartDate)} - {fortmatDates(payInAdvanceEndDate)}
        </Typography>
      </Grid>

      <Grid item xs={5}>
        <Typography className={classes.textEnd}>
          {keyEmptyCheck('due_rent_amount')} (
          {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(payInAdvanceRent ?? 0) })})
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.textEnd}>
          {keyEmptyCheck('vat_aed_', { num: formatCurrencyWithoutCurrency(payInAdvanceRentVat ?? 0) })}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default PayRentInAdvance;

PayRentInAdvance.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
};
